module.exports = __webpack_public_path__ + "img/GERA_Inside_Pic3.jpg";